import React, { useState } from "react"
import {
    TabContent,
    TabPane,
    Nav,
    NavItem,
    NavLink,
    Input,
    Label,
    FormGroup,
    Button,
    Alert,
    Container,
    Card,
    CardTitle,
    CardBody,
    CardText,
    CardHeader,
    CardFooter,
    ListGroup,
    ListGroupItem,
    Row,
    Col
} from "reactstrap"
import SpinnerWrap from "../Components/SpinnerWrap"
import { api } from "../apis/usertasks/api"
import { autocomplete } from "../libs/utils"
import classnames from "classnames"
import jwt from "jsonwebtoken"
import ido from "idexo-sdk"

const tasks = require("../constants/tasks.json")
// import tasks from "../constants/tasks.json"

const apiUrl = "https://admin.idexo.io/"
const stakerUrl = "https://stakers.idexo.io/"
const forsale = {}

const Admin = () => {
    const [activeTab, setActiveTab] = useState("1")
    const [userId, setUserId] = useState(null)
    const [validateCode, setValidateCode] = useState(null)
    const [userTasks, setUserTasks] = useState(tasks)
    const [discordUser, setDiscordUser] = useState("")

    // for method_credits tab
    const [showSpinner, setShowSpinner] = useState(false)
    const [alertMessage, setAlertMessage] = useState("")
    const [alertColor, setAlertColor] = useState("")

    // Surveys
    const [processSurvey, setProcessSurvey] = useState(false)
    const [loadedSurveys, setLoadedSurveys] = useState([])

    const [inputNetwork, setInputNetwork] = useState("fantom")
    const [inputContractType, setInputContractType] = useState("simple")
    const [inputContractAddress, setInputContractAddress] = useState(null)
    const [inputSurveyId, setInputSurveyId] = useState(0)
    const [inputSurveyTitle, setInputSurveyTitle] = useState(null)
    const [inputCreatorAddress, setInputCreatorAddress] = useState(null)

    // Products
    const [processProducts, setProcessProducts] = useState(false)
    const [loadedProducts, setLoadedProducts] = useState([])

    const [inputProductName, setInputProductName] = useState(null)
    const [inputProductId, setInputProductId] = useState(null)
    const [inputProductPayToken, setInputProducPayToken] = useState(null)
    const [inputProductPrice, setInputProductPrice] = useState(null)

    const handleTogglePage = (tab) => {
        localStorage.setItem("lastActive", new Date().getTime())
        if (tab !== activeTab) {
            setActiveTab(tab)
            let output = document.getElementById("output")
            output.innerText = ""
            if (tab == "5") {
                loadMethods()
            }
        }
    }

    const loadMethods = () => {
        fetch("https://costs.idexo.io/")
            .then((res) => res.json())
            .then((data) => {
                var methods = []
                if (data.data && data.data.Count > 0) {
                    for (let i = 0; i < data.data.Items.length; i++) {
                        methods.push(data.data.Items[i].item_name.S)
                    }
                }
                autocomplete(document.getElementById("method-name"), methods)
            })
            .catch((error) => {
                console.log(error)
            })
    }

    const handleResetUserTasks = () => {
        for (const key of Object.keys(userTasks)) {
            userTasks[key].value = "0"
            setUserTasks({ ...userTasks })
        }
    }

    const handleUserTasks = (key, value) => {
        userTasks[key].value = value
        setUserTasks({ ...userTasks })
    }

    const handleTaskValue = (e) => {
        userTasks[e.target.id].value = e.target.value
        setUserTasks({ ...userTasks })
    }

    const handleAddMethodCredits = (e) => {
        setAlertMessage("")
        let methodName = document.getElementById("method-name").value
        let credits = document.getElementById("credits").value
        if (methodName && credits) {
            setShowSpinner(true)
            fetch(apiUrl + "?path=credit", {
                method: "POST",
                headers: { token: localStorage.jwtToken },
                body: JSON.stringify({
                    user_id: userId,
                    method_name: methodName,
                    amount: credits
                })
            })
                .then((res) => res.json())
                .then((data) => {
                    if (data.error) {
                        setAlertMessage("Error: " + String(data.error))
                        setAlertColor("danger")
                    } else {
                        setAlertMessage(`success!, ${credits} added to method: ${methodName}`)
                        setAlertColor("success")
                        getUserCredits({ key: "Enter" })
                    }
                    setShowSpinner(false)
                })
                .catch((error) => {
                    console.log(error)
                    setAlertMessage("Error: " + String(error))
                    setAlertColor("danger")
                    setShowSpinner(false)
                })
        }
    }

    const filterTasks = (obj) => {
        const not_allowed = ["id", "updated", "user_id"]
        return Object.keys(obj)
            .filter((key) => !not_allowed.includes(key))
            .map((key) => ({ [key]: obj[key] }))
            .reduce((past, current) => {
                return { ...past, ...current }
            }, {})
    }

    const getCredit = (user_id) => {
        let actions = document.getElementById("searchCreditActions")
        let input = document.getElementById("searchCreditInput")
        let output = document.getElementById("output")
        fetch(apiUrl + "?path=credit&user_id=" + encodeURIComponent(user_id), {
            headers: { token: localStorage.jwtToken }
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.data && data.data.Count > 0) {
                    output.innerText = ""
                    for (let i = 0; i < data.data.Items.length; i++) {
                        const e = data.data.Items[i]
                        output.innerText += e.method_name.S + " = " + String(e.credit_balance.N) + "\n"
                    }
                } else {
                    output.innerText = "No credits found for this user"
                }
                input.disabled = false
                actions.style.display = "block"
            })
            .catch((error) => {
                console.log(error)
            })
    }

    const handleSurveyForm = (e) => {
        switch (e.target.id) {
            case "network":
                setInputNetwork(e.target.value)
                break
            case "contract_type":
                setInputContractType(e.target.value)
                break
            case "contract_address":
                setInputContractAddress(e.target.value)
                break
            case "survey_id":
                setInputSurveyId(e.target.value)
                break
            case "survey_title":
                setInputSurveyTitle(e.target.value)
                break
            case "creator_address":
                setInputCreatorAddress(e.target.value)
                break
            default:
                break
        }
    }

    const handleProductForm = (e) => {
        switch (e.target.id) {
            case "product_name":
                setInputProductName(e.target.value)
                break
            case "contract_type":
                setInputContractType(e.target.value)
                break
            case "contract_address":
                setInputContractAddress(e.target.value)
                break
            case "survey_id":
                setInputSurveyId(e.target.value)
                break
            case "survey_title":
                setInputSurveyTitle(e.target.value)
                break
            case "creator_address":
                setInputCreatorAddress(e.target.value)
                break
            default:
                break
        }
    }

    const getSubdomain = (event) => {
        if (event.key === "Enter") {
            let input = document.getElementById("searchSubdomain")
            let input1 = document.getElementById("subdomainOptionInput")
            let input2 = document.getElementById("subdomainOptionInput2")
            let output = document.getElementById("output")
            input.disabled = true
            output.innerText = ""
            fetch(apiUrl + "?path=subdomain&subdomain=" + input.value, {
                headers: { token: localStorage.jwtToken }
            })
                .then((res) => res.json())
                .then((json) => {
                    input.disabled = false
                    if (json.error) {
                        alert("Things are not going your way, server says: " + json.error)
                    } else if (!json.data) {
                        alert("No matches to your search...")
                    } else {
                        output.innerText = JSON.stringify(json.data, null, 4)
                        input1.style.display = "block"
                        input2.style.display = "block"
                    }
                })
                .catch((error) => {
                    console.log(error)
                    alert(String(error))
                })
        }
    }

    const updSubdomain = (event) => {
        if (event.key === "Enter") {
            let input = document.getElementById("searchSubdomain")
            let input1 = document.getElementById("subdomainOptionInput")
            let input2 = document.getElementById("subdomainOptionInput2")
            let output = document.getElementById("output")
            let data = {}
            data[input1.value] = input2.value
            output.innerText = ""
            fetch(apiUrl + "?path=subdomain&subdomain=" + input.value, {
                method: "POST",
                headers: { token: localStorage.jwtToken },
                body: JSON.stringify(data)
            })
                .then((res) => res.json())
                .then((json) => {
                    if (json.error) {
                        alert("Things are not going your way, server says: " + json.error)
                    } else {
                        output.innerText = JSON.stringify(json.data, null, 4)
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        }
    }

    const getContract = (event) => {
        if (event.key === "Enter") {
            let input = document.getElementById("searchContractInput")
            let input2 = document.getElementById("contractNewOwnerInput")
            let output = document.getElementById("output")
            input.disabled = true
            fetch(apiUrl + "?path=contract&contract=" + encodeURIComponent(input.value), {
                headers: { token: localStorage.jwtToken }
            })
                .then((res) => res.json())
                .then((json) => {
                    input.disabled = false
                    input2.style.display = "block"
                    if (json.error) {
                        alert("Things are not going your way, server says: " + json.error)
                    } else if (!json.data) {
                        alert("No matches to your search...")
                        output.innerText = ""
                    } else {
                        output.innerText = JSON.stringify(json.data, null, 4)
                    }
                })
                .catch((error) => {
                    console.log(error)
                    alert(String(error))
                })
        }
    }

    const newContractOwner = async (event) => {
        if (event.key === "Enter") {
            let input = document.getElementById("searchContractInput")
            let input2 = document.getElementById("contractNewOwnerInput")
            let output = document.getElementById("output")
            input.disabled = true
            try {
                var decoded = jwt.decode(localStorage.jwtToken)
                var net = JSON.parse(output.innerText).network.S
                let x = await ido.Common.transferOwnership(decoded.api_key, net, input.value, input2.value)
                output.innerText = JSON.stringify(x.data.data, null, 4)
            } catch (error) {
                console.log(error.response.data)
            }
        }
    }

    const getUserCredits = (event) => {
        if (event.key === "Enter") {
            setUserId(null)
            handleResetUserTasks()
            let span = document.getElementById("emailSpan")
            let input = document.getElementById("searchCreditInput")
            let output = document.getElementById("output")

            input.disabled = true
            fetch(apiUrl + "?path=user&email=" + encodeURIComponent(input.value), {
                headers: { token: localStorage.jwtToken }
            })
                .then((res) => res.json())
                .then((data) => {
                    input.disabled = false
                    setTimeout(() => (span.className = "bx bx-mail-send"), 500)
                    if (data.error) {
                        alert("Things are not going your way, server says: " + data.error)
                    } else if (data.data.Count === 0) {
                        setUserId(null)
                        alert("No user matches your search...")
                        output.innerText = ""
                    } else {
                        let user_id = data.data.Items[0].id.S
                        setUserId(user_id)
                        getCredit(user_id)
                    }
                })
                .catch((error) => {
                    console.log(error)
                    alert(String(error))
                })
        }
    }

    const getUserTasks = (event) => {
        if (event.key === "Enter") {
            setUserId(null)
            handleResetUserTasks()
            let span = document.getElementById("emailSpan")
            let input = document.getElementById("searchInput")
            input.disabled = true
            fetch(apiUrl + "?path=user&email=" + encodeURIComponent(input.value), {
                headers: { token: localStorage.jwtToken }
            })
                .then((res) => res.json())
                .then((data) => {
                    input.disabled = false
                    setTimeout(() => (span.className = "bx bx-mail-send"), 500)
                    if (data.error) {
                        alert("Things are not going your way, server says: " + data.error)
                    } else if (data.data.Count === 0) {
                        setUserId(null)
                        alert("No user matches your search...")
                    } else {
                        let user_id = data.data.Items[0].id.S
                        setUserId(user_id)
                        fetch(apiUrl + "?path=task&user_id=" + encodeURIComponent(user_id) + "&id=community_key", {
                            headers: { token: localStorage.jwtToken }
                        })
                            .then((res) => res.json())
                            .then((data) => {
                                if (data.data && data.data.Count > 0) {
                                    let result = filterTasks(data.data.Items[0])
                                    for (const key of Object.keys(result)) {
                                        handleUserTasks(key, result[key].S)
                                    }
                                }
                                input.disabled = false
                            })
                            .catch((error) => {
                                console.log(error)
                            })
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        }
    }

    const genStakerValCode = () => {
        setValidateCode(null)
        let inputDiscorduser = document.getElementById("discordUserInput")

        if (discordUser) {
            inputDiscorduser.disabled = true
            fetch(stakerUrl + "?id=" + encodeURIComponent(discordUser), {
                method: "GET",
                headers: { token: localStorage.jwtToken }
            })
                .then((res) => res.json())
                .then((data) => {
                    inputDiscorduser.disabled = false
                    if (data.error) {
                        setValidateCode(null)
                        alert("Things are not going your way, server says: " + data.error)
                    } else {
                        let codeToValidate = data.data?.code.S
                        setValidateCode(codeToValidate)
                    }
                })
                .catch((error) => {
                    console.log(error)
                    inputDiscorduser.disabled = false
                })
        }
    }

    const updateUserTask = () => {
        let body = {
            id: "community_key",
            user_id: userId
        }

        for (const key of Object.keys(userTasks)) {
            body[key] = userTasks[key].value
        }

        api.updateUserTask(body).then((data) => {
            alert(data ? "Update completed sucessfully!" : "Error updating!")
        })
    }

    const getUser = (event) => {
        if (event.key === "Enter") {
            let span = document.getElementById("emailSpan")
            let input = document.getElementById("emailInput")
            let output = document.getElementById("output")
            input.disabled = true
            span.className = "bx bx-hourglass"
            fetch(apiUrl + "?path=user&email=" + encodeURIComponent(input.value), {
                headers: { token: localStorage.jwtToken }
            })
                .then((res) => res.json())
                .then((data) => {
                    input.disabled = false
                    setTimeout(() => (span.className = "bx bx-mail-send"), 500)
                    if (data.error) {
                        alert("Things are not going your way, server says: " + data.error)
                    } else if (data.data.Count == 0) {
                        alert("No user matches your search...")
                    } else {
                        output.innerText = JSON.stringify(data.data.Items, null, 4)
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        }
    }

    const getBalance = (event) => {
        if (event.key === "Enter") {
            let span = document.getElementById("balanceSpan")
            let input = document.getElementById("balanceInput")
            let output = document.getElementById("output")
            input.disabled = true
            span.className = "bx bx-hourglass"
            fetch(apiUrl + "?path=balance&user_id=" + encodeURIComponent(input.value), {
                headers: { token: localStorage.jwtToken }
            })
                .then((res) => res.json())
                .then((data) => {
                    input.disabled = false
                    setTimeout(() => (span.className = "bx bx-key"), 500)
                    if (data.error) {
                        alert("Things are not going your way, server says: " + data.error)
                    } else if (data.data.Count == 0) {
                        alert("No data found...")
                    } else {
                        output.innerText = JSON.stringify(data.data, null, 4)
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        }
    }

    const setOrigin = (event) => {
        if (event.key === "Enter") {
            let output = document.getElementById("output")
            let span = document.getElementById("originSpan")
            let input = document.getElementById("originInput")
            let email = document.getElementById("originEmail")
            if (input.value && email.value) {
                output.innerText = ""
                if (input.validity.patternMismatch) {
                    alert("Invalid input")
                } else {
                    input.disabled = email.disabled = true
                    span.className = "bx bx-hourglass"
                    fetch(apiUrl + "?path=user&action=origin", {
                        method: "POST",
                        headers: { token: localStorage.jwtToken },
                        body: JSON.stringify({
                            email: email.value,
                            origin: input.value
                        })
                    })
                        .then((res) => res.json())
                        .then((data) => {
                            input.disabled = email.disabled = false
                            setTimeout(() => (span.className = "bx bx-mail-send"), 500)
                            if (data.error) {
                                alert("Things are not going your way, server says: " + data.error)
                            } else {
                                output.innerText = JSON.stringify(data.data.Attributes, null, 4)
                            }
                        })
                        .catch((error) => {
                            console.log(error)
                        })
                }
            }
        }
    }

    const setAccount = (event) => {
        if (event.key === "Enter") {
            let output = document.getElementById("output")
            let span = document.getElementById("accountSpan")
            let input = document.getElementById("accountInput")
            let email = document.getElementById("accountEmail")
            if (input.value && email.value) {
                output.innerText = ""
                if (input.validity.patternMismatch) {
                    alert("Invalid input")
                } else {
                    input.disabled = email.disabled = true
                    span.className = "bx bx-hourglass"
                    fetch(apiUrl + "?path=user&action=account", {
                        method: "POST",
                        headers: { token: localStorage.jwtToken },
                        body: JSON.stringify({
                            email: email.value,
                            account: input.value
                        })
                    })
                        .then((res) => res.json())
                        .then((data) => {
                            input.disabled = email.disabled = false
                            setTimeout(() => (span.className = "bx bx-mail-send"), 500)
                            if (data.error) {
                                alert("Things are not going your way, server says: " + data.error)
                            } else {
                                output.innerText = JSON.stringify(data.data.Attributes, null, 4)
                            }
                        })
                        .catch((error) => {
                            console.log(error)
                        })
                }
            }
        }
    }

    const setPaid = (event) => {
        if (event.key === "Enter") {
            let output = document.getElementById("output")
            let span = document.getElementById("paidSpan")
            let input = document.getElementById("paidInput")
            let email = document.getElementById("paidEmail")
            if (input.value && email.value) {
                output.innerText = ""
                if (input.validity.patternMismatch) {
                    alert("Invalid input")
                } else {
                    input.disabled = email.disabled = true
                    span.className = "bx bx-hourglass"
                    fetch(apiUrl + "?path=user&action=paid", {
                        method: "POST",
                        headers: { token: localStorage.jwtToken },
                        body: JSON.stringify({
                            email: email.value,
                            paid: input.value
                        })
                    })
                        .then((res) => res.json())
                        .then((data) => {
                            input.disabled = email.disabled = false
                            setTimeout(() => (span.className = "bx bx-mail-send"), 500)
                            if (data.error) {
                                alert("Things are not going your way, server says: " + data.error)
                            } else {
                                output.innerText = JSON.stringify(data.data.Attributes, null, 4)
                            }
                        })
                        .catch((error) => {
                            console.log(error)
                        })
                }
            }
        }
    }

    const setApikey = (event) => {
        if (event.key === "Enter") {
            let output = document.getElementById("output")
            let span = document.getElementById("apikeySpan")
            let input = document.getElementById("apikeyInput")
            let email = document.getElementById("apikeyEmail")
            if (input.value && email.value) {
                output.innerText = ""
                if (input.validity.patternMismatch) {
                    alert("Invalid input")
                } else {
                    input.disabled = email.disabled = true
                    span.className = "bx bx-hourglass"
                    fetch(apiUrl + "?path=user&action=apikey", {
                        method: "POST",
                        headers: { token: localStorage.jwtToken },
                        body: JSON.stringify({
                            email: email.value,
                            apikey: input.value
                        })
                    })
                        .then((res) => res.json())
                        .then((data) => {
                            input.disabled = email.disabled = false
                            setTimeout(() => (span.className = "bx bx-mail-send"), 500)
                            if (data.error) {
                                alert("Things are not going your way, server says: " + data.error)
                            } else {
                                output.innerText = JSON.stringify(data.data.Attributes, null, 4)
                            }
                        })
                        .catch((error) => {
                            console.log(error)
                        })
                }
            }
        }
    }

    const setReferral = (event) => {
        if (event.key === "Enter") {
            let output = document.getElementById("output")
            let span = document.getElementById("referralSpan")
            let input = document.getElementById("referralInput")
            let email = document.getElementById("referralEmail")
            if (input.value && email.value) {
                output.innerText = ""
                if (input.validity.patternMismatch) {
                    alert("Invalid input")
                } else {
                    input.disabled = email.disabled = true
                    span.className = "bx bx-hourglass"
                    fetch(apiUrl + "?path=user&action=referral", {
                        method: "POST",
                        headers: { token: localStorage.jwtToken },
                        body: JSON.stringify({
                            email: email.value,
                            referral: input.value
                        })
                    })
                        .then((res) => res.json())
                        .then((data) => {
                            input.disabled = email.disabled = false
                            setTimeout(() => (span.className = "bx bx-mail-send"), 500)
                            if (data.error) {
                                alert("Things are not going your way, server says: " + data.error)
                            } else {
                                output.innerText = JSON.stringify(data.data.Attributes, null, 4)
                            }
                        })
                        .catch((error) => {
                            console.log(error)
                        })
                }
            }
        }
    }

    const getWallet = (event) => {
        if (event.key === "Enter") {
            let span = document.getElementById("walletSpan")
            let input = document.getElementById("walletInput")
            let output = document.getElementById("output")
            input.disabled = true
            span.className = "bx bx-hourglass"
            fetch(apiUrl + "?path=wallet&user_id=" + encodeURIComponent(input.value), {
                headers: { token: localStorage.jwtToken }
            })
                .then((res) => res.json())
                .then((data) => {
                    input.disabled = false
                    setTimeout(() => (span.className = "bx bx-key"), 500)
                    if (data.error) {
                        alert("Things are not going your way, server says: " + data.error)
                    } else if (data.data.Count == 0) {
                        alert("No data found...")
                    } else {
                        output.innerText = JSON.stringify(data.data.Items, null, 4)
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        }
    }

    const getForsale = (event) => {
        if (event.key === "Enter") {
            let output = document.getElementById("output")
            let api_url = "https://nft.idexo.io/?"
            api_url += "&min=" + document.getElementById("forsalemin").value
            api_url += "&max=" + document.getElementById("forsalemax").value
            api_url += "&limit=" + document.getElementById("forsalelimit").value
            if (forsale.data && forsale.data.LastEvaluatedKey) {
                api_url += "&startkey=" + encodeURIComponent(JSON.stringify(forsale.data.LastEvaluatedKey))
            }
            output.innerText = ""
            fetch(api_url, { headers: { token: localStorage.jwtToken } })
                .then((res) => res.json())
                .then((data) => {
                    if (data.error) {
                        alert("Things are not going your way, server says: " + data.error)
                    } else if (data.data.Count == 0) {
                        alert("No data found...")
                    } else {
                        output.innerText = JSON.stringify(data.data.Items, null, 4)
                        forsale.data = data.data
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        }
    }

    const getPendingNft = (event) => {
        if (event.key === "Enter") {
            let input = document.getElementById("nftInput")
            let output = document.getElementById("output")
            input.disabled = true
            fetch(apiUrl + "?path=nft&wallet=" + encodeURIComponent(input.value), {
                headers: { token: localStorage.jwtToken }
            })
                .then((res) => res.json())
                .then((data) => {
                    input.disabled = false
                    if (data.error) {
                        alert("Things are not going your way, server says: " + data.error)
                    } else if (data.data.Count == 0) {
                        alert("No data found...")
                    } else {
                        output.innerText = JSON.stringify(data.data.Items, null, 4)
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        }
    }

    const changePendingNft = (event) => {
        if (event.key === "Enter" && window.confirm("This will change the step... Are you sure?")) {
            let wallet = document.getElementById("nftChangeInput")
            let step = document.getElementById("nftChangeStepInput")
            if (wallet.value && step.value) {
                let output = document.getElementById("output")
                wallet.disabled = step.disabled = true
                fetch(apiUrl + "?path=nft&wallet=" + wallet.value + "&step=" + step.value, {
                    method: "POST",
                    headers: { token: localStorage.jwtToken }
                })
                    .then((res) => res.json())
                    .then((data) => {
                        wallet.disabled = step.disabled = false
                        if (data.error) {
                            alert("Things are not going your way, server says: " + data.error)
                        } else if (!data) {
                            alert("No data found...")
                        } else {
                            output.innerText = JSON.stringify(data, null, 4)
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        }
    }

    const getSurveyList = async () => {
        setProcessSurvey(true)
        fetch(apiUrl + "?path=survey", {
            headers: { token: localStorage.jwtToken }
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.error) {
                    alert("Things are not going your way, server says: " + data.error)
                } else if (data.data.Count === 0) {
                    alert("No surveys...")
                } else {
                    setLoadedSurveys(data.data.Items)
                }
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                setProcessSurvey(false)
            })
    }

    const addSurvey = async () => {
        setProcessSurvey(true)
        var formData = {
            network: inputNetwork,
            contractAddress: inputContractAddress,
            contractType: inputContractType,
            surveyTitle: inputSurveyTitle,
            creator: inputCreatorAddress
        }
        if (inputContractType === "multiple") {
            formData.surveyId = inputSurveyId
        }

        fetch(apiUrl + "?path=survey", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json", token: localStorage.jwtToken },
            body: JSON.stringify(formData)
        })
            .then(() => {
                getSurveyList()
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                setProcessSurvey(false)
            })
    }

    const deleteSurvey = async (surveyId) => {
        setProcessSurvey(true)
        fetch(apiUrl + `?path=survey&id=${surveyId}`, {
            method: "DELETE",
            headers: { token: localStorage.jwtToken }
        })
            .then(() => {
                getSurveyList()
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                setProcessSurvey(false)
            })
    }

    const getProductList = async () => {
        setProcessProducts(true)
        fetch(apiUrl + "?path=products", {
            headers: { token: localStorage.jwtToken }
        })
            .then((res) => res.json())
            .then((data) => {
                console.log(data)
                if (data.error) {
                    alert("Things are not going your way, server says: " + data.error)
                } else if (data.data.Count === 0) {
                    alert("No products...")
                } else {
                    console.log(data.data)
                    setLoadedProducts(data.data.Items)
                }
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                setProcessProducts(false)
            })
    }

    const addProduct = async () => {
        setProcessProducts(true)
        var formData = {
            name: inputProductName
        }

        fetch(apiUrl + "?path=products", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json", token: localStorage.jwtToken },
            body: JSON.stringify(formData)
        })
            .then(() => {
                getProductList()
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                setProcessProducts(false)
            })
    }

    const deleteProduct = async (pproductId) => {
        setProcessProducts(true)
        fetch(apiUrl + `?path=products&id=${pproductId}`, {
            method: "DELETE",
            headers: { token: localStorage.jwtToken }
        })
            .then(() => {
                getSurveyList()
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                setProcessProducts(false)
            })
    }

    return (
        <div className="admin-page">
            <Nav tabs>
                {[
                    "User Settings",
                    "Manage Tasks",
                    "Generate Validation Codes",
                    "NFT Queries",
                    "Method Credits",
                    "Contracts",
                    "Surveys",
                    "Subdomains",
                    "Products"
                ].map((e, i) => {
                    return (
                        <NavItem>
                            <NavLink className={classnames({ active: activeTab === String(i + 1) })} onClick={() => handleTogglePage(String(i + 1))}>
                                {e}
                            </NavLink>
                        </NavItem>
                    )
                })}
            </Nav>
            <TabContent activeTab={activeTab}>
                <TabPane tabId="1">
                    <div className="content">
                        <h2>Admin options, proceed with caution!</h2>
                        <hr></hr>
                        <div className="app-email d-lg-block">
                            Enter user email:
                            <div className="position-relative">
                                <input id="emailInput" type="text" className="form-control" onKeyPress={getUser} />
                                <span id="emailSpan" className="bx bx-mail-send"></span>
                            </div>
                        </div>
                        <div className="app-email d-lg-block">
                            Enter user id to retrieve balance history:
                            <div className="position-relative">
                                <input id="balanceInput" type="text" className="form-control" onKeyPress={getBalance} />
                                <span id="balanceSpan" className="bx bx-key"></span>
                            </div>
                        </div>
                        <div className="app-email d-lg-block">
                            Enter user id to retrieve wallets:
                            <div className="position-relative">
                                <input id="walletInput" type="text" className="form-control" onKeyPress={getWallet} />
                                <span id="walletSpan" className="bx bx-key"></span>
                            </div>
                        </div>
                        <hr></hr>
                        <div className="d-lg-block">
                            Update origin attribute:
                            <div className="form-control">
                                <span id="originSpan" className="bx bx-mail-send"></span>
                                <input id="originEmail" type="text" onKeyPress={setOrigin} placeholder="email" />
                                <input
                                    id="originInput"
                                    className="v-input"
                                    type="text"
                                    onKeyPress={setOrigin}
                                    placeholder="origin"
                                    pattern="^http.*"
                                    title="origin value, something like: https://app.idexo.io"
                                />
                            </div>
                        </div>
                        <hr></hr>
                        <div className="d-lg-block">
                            Update account attribute:
                            <div className="form-control">
                                <span id="accountSpan" className="bx bx-mail-send"></span>
                                <input id="accountEmail" type="text" onKeyPress={setAccount} placeholder="email" />
                                <input
                                    id="accountInput"
                                    className="v-input"
                                    type="text"
                                    onKeyPress={setAccount}
                                    placeholder="account"
                                    pattern="(0|1|2|3)"
                                    title="account value, only numbers from 0 to 3 allowed"
                                />
                            </div>
                        </div>
                        <hr></hr>
                        <div className="d-lg-block">
                            Update paid attribute:
                            <div className="form-control">
                                <span id="paidSpan" className="bx bx-mail-send"></span>
                                <input id="paidEmail" type="text" onKeyPress={setPaid} placeholder="email" />
                                <input
                                    id="paidInput"
                                    className="v-input"
                                    type="text"
                                    onKeyPress={setPaid}
                                    placeholder="paid"
                                    pattern="(0|1|2|3|4|5|6)"
                                    title="paid value, only (0 to 6) allowed"
                                />
                            </div>
                        </div>
                        <hr></hr>
                        <div className="d-lg-block">
                            Update api_key attribute:
                            <div className="form-control">
                                <span id="apikeySpan" className="bx bx-mail-send"></span>
                                <input id="apikeyEmail" type="text" onKeyPress={setApikey} placeholder="email" />
                                <input id="apikeyInput" className="v-input" type="text" onKeyPress={setApikey} placeholder="api key" />
                            </div>
                        </div>
                        <hr></hr>
                        <div className="d-lg-block">
                            Update referral attribute:
                            <div className="form-control">
                                <span id="referralSpan" className="bx bx-mail-send"></span>
                                <input id="referralEmail" type="text" onKeyPress={setReferral} placeholder="email" />
                                <input id="referralInput" className="v-input" type="text" onKeyPress={setReferral} placeholder="referral" />
                            </div>
                        </div>
                    </div>
                </TabPane>
                <TabPane tabId="2">
                    <div className="content">
                        <h2>Manage task completion</h2>
                        <hr></hr>
                        <div className="app-email d-lg-block">
                            Search user:
                            <div className="position-relative">
                                <input
                                    id="searchInput"
                                    type="text"
                                    className="form-control"
                                    onChange={() => {
                                        setUserId(null)
                                        handleResetUserTasks()
                                    }}
                                    onKeyPress={getUserTasks}
                                />
                                <span id="emailSpan" className="bx bx-search"></span>
                            </div>
                        </div>
                        <hr></hr>
                        <div>
                            {userId !== null
                                ? Object.keys(userTasks).map((key, i) => (
                                      <div className="form-control" key={key}>
                                          <h3>
                                              {userTasks[key].name} - {userTasks[key].cred}
                                          </h3>

                                          <input
                                              className="border h4 form-form-control-sm"
                                              type="number"
                                              id={key}
                                              value={userTasks[key].value}
                                              onChange={(e) => handleTaskValue(e)}
                                          />
                                      </div>
                                  ))
                                : null}
                        </div>
                        {userId !== null ? (
                            <button className="btn-primary h2 text-white p-2" onClick={updateUserTask}>
                                Update
                            </button>
                        ) : null}
                    </div>
                </TabPane>
                <TabPane tabId="3">
                    <div className="content">
                        <h2>New validation code for staker</h2>
                        <hr></hr>
                        <div className="app-email d-lg-block">
                            Discord username:
                            <div className="position-relative">
                                <input
                                    id="discordUserInput"
                                    type="text"
                                    value={discordUser}
                                    className="form-control"
                                    onChange={(e) => {
                                        setDiscordUser(e.target.value)
                                    }}
                                />
                            </div>
                        </div>
                        <br />
                        <div>
                            <button className="btn-primary h2 text-white p-2" onClick={genStakerValCode}>
                                Generate code
                            </button>
                        </div>
                        <hr></hr>
                        <div>
                            {validateCode !== null ? (
                                <div>
                                    <h1>Code to validate:</h1>
                                    <h2>{validateCode}</h2>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </TabPane>
                <TabPane tabId="4">
                    <div className="content">
                        <h2>NFT queries</h2>
                        <hr></hr>
                        <div className="d-lg-block">
                            Query NFTs for sale:
                            <div className="form-control">
                                <input id="forsalemin" type="text" onKeyPress={getForsale} placeholder="min" />
                                <input id="forsalemax" type="text" onKeyPress={getForsale} placeholder="max" />
                                <input id="forsalelimit" type="text" onKeyPress={getForsale} placeholder="limit" />
                            </div>
                        </div>
                        <hr></hr>
                        <div className="d-lg-block">
                            Query pending NFTs:
                            <div className="form-control">
                                <input id="nftInput" type="text" size="45" onKeyPress={getPendingNft} placeholder="wallet" />
                            </div>
                            Change step on pending NFTs :
                            <div className="form-control">
                                <input id="nftChangeInput" type="text" size="45" onKeyPress={changePendingNft} placeholder="wallet" />
                                <input id="nftChangeStepInput" type="text" onKeyPress={changePendingNft} placeholder="step" />
                            </div>
                        </div>
                    </div>
                </TabPane>
                <TabPane tabId="5">
                    <div className="credit-content">
                        <h2>Manage the methods credit for the users</h2>
                        <hr></hr>
                        <div className="app-email d-lg-block">
                            Search user:
                            <div className="position-relative">
                                <input
                                    id="searchCreditInput"
                                    type="text"
                                    className="form-control"
                                    onChange={() => {
                                        setUserId(null)
                                        handleResetUserTasks()
                                    }}
                                    onKeyPress={getUserCredits}
                                />
                                <span id="emailSpan" className="bx bx-search"></span>
                            </div>
                        </div>
                        <hr></hr>
                        <div id="searchCreditActions" className="update-method-credits-row" style={{ display: "none" }}>
                            Add Method Credits:
                            <table>
                                <tr className="credits-row">
                                    <td>
                                        <FormGroup>
                                            <div class="autocomplete">
                                                <Input
                                                    type="text"
                                                    id="method-name"
                                                    placeholder="Enter method_name"
                                                    style={{ width: "400px" }}
                                                    autocomplete="off"
                                                />
                                            </div>
                                        </FormGroup>
                                    </td>
                                    <td>
                                        <FormGroup>
                                            <Input type="number" id="credits" placeholder="Enter credits to add" />
                                        </FormGroup>
                                    </td>
                                    <td>
                                        <Button
                                            color="primary"
                                            className="waves-effect w-xl me-3"
                                            type="submit"
                                            disabled={!userId || showSpinner}
                                            onClick={handleAddMethodCredits}
                                        >
                                            <SpinnerWrap showSpinner={showSpinner} txtTrue={"ADDING"} txtFalse={"ADD"} />
                                        </Button>
                                    </td>
                                </tr>
                            </table>
                            <Alert color={alertColor} toggle={() => setAlertMessage("")} isOpen={!!alertMessage}>
                                {alertMessage}
                            </Alert>
                        </div>
                    </div>
                </TabPane>
                <TabPane tabId="6">
                    <div className="content">
                        <h2>Manage the contract deployed by users</h2>
                        <hr></hr>
                        <div className="app-email d-lg-block">
                            Search contract:
                            <div className="position-relative">
                                <input id="searchContractInput" type="text" className="form-control" onKeyPress={getContract} />
                                <input
                                    id="contractNewOwnerInput"
                                    type="text"
                                    style={{ display: "none" }}
                                    className="form-control"
                                    placeholder="new contract owner"
                                    onKeyPress={newContractOwner}
                                />
                            </div>
                        </div>
                        <hr></hr>
                    </div>
                </TabPane>
                <TabPane tabId="7">
                    <div className="content">
                        <Row>
                            <Col>
                                <Card>
                                    <CardBody>
                                        <FormGroup key="form">
                                            <Row>
                                                <Col md={6}>
                                                    <Label for="network">Network</Label>
                                                    <Input
                                                        className="mb-2"
                                                        key={"network"}
                                                        id="network"
                                                        type="select"
                                                        onChange={handleSurveyForm}
                                                        value={inputNetwork}
                                                    >
                                                        <option value={"avalanche"}>Avalanche</option>
                                                        <option value={"binance"}>Binance Smart Chain</option>
                                                        <option value={"ethereum"}>Ethereum</option>
                                                        <option value={"fantom"}>Fantom</option>
                                                        <option value={"polygon"}>Polygon</option>
                                                    </Input>
                                                </Col>
                                                <Col md={6}>
                                                    <Label for="contract_type">Contract Type</Label>
                                                    <Input
                                                        className="mb-2"
                                                        key={"contract_type"}
                                                        id="contract_type"
                                                        type="select"
                                                        onChange={handleSurveyForm}
                                                        value={inputContractType}
                                                    >
                                                        <option value={"simple"}>Simple</option>
                                                        <option value={"multiple"}>Multiple</option>
                                                    </Input>
                                                </Col>
                                            </Row>
                                            <Col>
                                                <Label for="contract_address">Contract Address</Label>
                                                <Input
                                                    className="mb-2"
                                                    value={inputContractAddress}
                                                    key={"contract_address"}
                                                    id="contract_address"
                                                    type="text"
                                                    onChange={handleSurveyForm}
                                                ></Input>
                                                {inputContractType !== "simple" ? (
                                                    <>
                                                        <Label for="survey_id">Survey Id</Label>
                                                        <Input
                                                            className="mb-2"
                                                            value={inputSurveyId}
                                                            key={"survey_id"}
                                                            id="survey_id"
                                                            type="number"
                                                            onChange={handleSurveyForm}
                                                        ></Input>
                                                    </>
                                                ) : null}

                                                <Label for="survey_title">Survey Title</Label>
                                                <Input
                                                    className="mb-2"
                                                    value={inputSurveyTitle}
                                                    key={"survey_title"}
                                                    id="survey_title"
                                                    type="text"
                                                    onChange={handleSurveyForm}
                                                ></Input>
                                                <Label for="creator_address">Creator Address</Label>
                                                <Input
                                                    className="mb-2"
                                                    value={inputCreatorAddress}
                                                    key={"creator_address"}
                                                    id="creator_address"
                                                    type="text"
                                                    onChange={handleSurveyForm}
                                                ></Input>
                                            </Col>
                                        </FormGroup>
                                    </CardBody>
                                    <CardFooter>
                                        <Row>
                                            <Col sm={3}>
                                                <Button
                                                    disabled={processSurvey}
                                                    color="primary"
                                                    onClick={() => {
                                                        addSurvey()
                                                    }}
                                                >
                                                    Add Survey
                                                </Button>
                                            </Col>
                                        </Row>
                                    </CardFooter>
                                </Card>
                            </Col>
                        </Row>
                        <hr></hr>
                        <Row>
                            <Col>
                                <Card>
                                    <CardBody>
                                        <Button disabled={processSurvey} onClick={() => getSurveyList()}>
                                            Get Surveys
                                        </Button>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <hr></hr>
                        <Row>
                            {loadedSurveys.length > 0
                                ? loadedSurveys.map((survey) => {
                                      return (
                                          <Col key={survey.id.S} sm={6}>
                                              <Card>
                                                  <CardBody>
                                                      <ListGroup flush>
                                                          <ListGroupItem>Id: {survey.id.S}</ListGroupItem>
                                                          <ListGroupItem>Title: {survey.title.S}</ListGroupItem>
                                                          <ListGroupItem>Network: {survey.network.S}</ListGroupItem>
                                                          <ListGroupItem>Contract: {survey.contract.S}</ListGroupItem>
                                                          <ListGroupItem>Contract Type: {survey.contract_type.S}</ListGroupItem>
                                                          {survey.contract_type.S !== "simple" ? (
                                                              <ListGroupItem>Survey Id: {survey.survey_id.S}</ListGroupItem>
                                                          ) : null}
                                                          <ListGroupItem>Creator: {survey.creator.S}</ListGroupItem>
                                                      </ListGroup>
                                                  </CardBody>
                                                  <CardFooter>
                                                      <Button disabled={processSurvey} color="danger" onClick={() => deleteSurvey(survey.id.S)}>
                                                          Remove
                                                      </Button>
                                                  </CardFooter>
                                              </Card>
                                          </Col>
                                      )
                                  })
                                : null}
                        </Row>
                    </div>
                </TabPane>

                <TabPane tabId="8">
                    <div className="content">
                        <h2>Manage the Subdomains</h2>
                        <hr></hr>
                        <div className="app-email d-lg-block">
                            Search Subdomain:
                            <div className="position-relative">
                                <input id="searchSubdomain" type="text" className="form-control" onKeyPress={getSubdomain} />
                                <input
                                    id="subdomainOptionInput"
                                    type="text"
                                    style={{ display: "none" }}
                                    className="form-control"
                                    placeholder="attribute"
                                />
                                <input
                                    id="subdomainOptionInput2"
                                    type="number"
                                    style={{ display: "none" }}
                                    className="form-control"
                                    placeholder="attribute value"
                                    onKeyPress={updSubdomain}
                                />
                            </div>
                        </div>
                        <hr></hr>
                    </div>
                </TabPane>
                <TabPane tabId="9">
                    <div className="content">
                        <Row>
                            <Col>
                                <Card>
                                    <CardBody>
                                        <FormGroup key="form">
                                            <Row>
                                                <Col md={6}>
                                                    <Label for="product_id">Product Id</Label>
                                                    <Input
                                                        className="mb-2"
                                                        key={"product_id"}
                                                        id="product_id"
                                                        type="text"
                                                        onChange={handleProductForm}
                                                        value={inputProductName}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={6}>
                                                    <Label for="payment_token">Payment Token</Label>
                                                    <Input
                                                        className="mb-2"
                                                        key={"payment_token"}
                                                        id="payment_token"
                                                        type="text"
                                                        onChange={handleProductForm}
                                                        value={inputProductPayToken}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={6}>
                                                    <Label for="price">Price</Label>
                                                    <Input
                                                        className="mb-2"
                                                        key={"price"}
                                                        id="price"
                                                        type="text"
                                                        onChange={handleProductForm}
                                                        value={inputProductPrice}
                                                    />
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                    </CardBody>
                                    <CardFooter>
                                        <Row>
                                            <Col sm={3}>
                                                <Button
                                                    disabled={processProducts}
                                                    color="primary"
                                                    onClick={() => {
                                                        addProduct()
                                                    }}
                                                >
                                                    Add Product
                                                </Button>
                                            </Col>
                                        </Row>
                                    </CardFooter>
                                </Card>
                            </Col>
                        </Row>
                        <hr></hr>
                        <Row>
                            <Col>
                                <Card>
                                    <CardBody>
                                        <Button disabled={processProducts} onClick={() => getProductList()}>
                                            Get Products
                                        </Button>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <hr></hr>
                        {/* <Row>
                            {loadedSurveys.length > 0
                                ? loadedSurveys.map((survey) => {
                                      return (
                                          <Col key={survey.id.S} sm={6}>
                                              <Card>
                                                  <CardBody>
                                                      <ListGroup flush>
                                                          <ListGroupItem>Id: {survey.id.S}</ListGroupItem>
                                                          <ListGroupItem>Title: {survey.title.S}</ListGroupItem>
                                                          <ListGroupItem>Network: {survey.network.S}</ListGroupItem>
                                                          <ListGroupItem>Contract: {survey.contract.S}</ListGroupItem>
                                                          <ListGroupItem>Contract Type: {survey.contract_type.S}</ListGroupItem>
                                                          {survey.contract_type.S !== "simple" ? (
                                                              <ListGroupItem>Survey Id: {survey.survey_id.S}</ListGroupItem>
                                                          ) : null}
                                                          <ListGroupItem>Creator: {survey.creator.S}</ListGroupItem>
                                                      </ListGroup>
                                                  </CardBody>
                                                  <CardFooter>
                                                      <Button disabled={processSurvey} color="danger" onClick={() => deleteSurvey(survey.id.S)}>
                                                          Remove
                                                      </Button>
                                                  </CardFooter>
                                              </Card>
                                          </Col>
                                      )
                                  })
                                : null}
                        </Row> */}
                    </div>
                </TabPane>
            </TabContent>
            <hr></hr>
            <div className="content">
                <pre id="output"></pre>
            </div>
        </div>
    )
}

export default Admin
